import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { Drawer } from '@bcp-channels-sharedcomponents-reactjs/feedback';
import { Box, PDFViewer } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { PDFViewerWebInstance } from '@bcp-nextgen-dx-component-factory/accolade-design-system/dist/molecules/PDFViewer/PDFViewer.models';
import { rem } from '@helpers';
import { useDrawer } from '@hooks';
import React from 'react';

export interface PdfViewerDrawerProps {
	title: string;
	subtitle: string;
	base64: string;
	drawerUniqueName: string;
	handleOnClickAcceptTerms: () => void;
	wasAccepted?: boolean;
}

export const PdfViewerDrawer: React.FC<PdfViewerDrawerProps> = ({
	base64,
	drawerUniqueName,
	handleOnClickAcceptTerms,
	title,
	subtitle,
	wasAccepted,
}) => {
	const t = useTranslation();
	const { hide: hidePdfDrawer } = useDrawer(drawerUniqueName);
	const ref = React.useRef<PDFViewerWebInstance>(null);
	const drawerTopDistance = 55;
	const pdfViewerHeight = window.innerHeight - drawerTopDistance;
	const [scrolled, setScrolled] = React.useState(false);

	const onScrolled = () => {
		setScrolled(true);
	};

	return (
		<>
			<Drawer
				name={drawerUniqueName}
				customDragHandle={<span></span>}
				childrenContentStyle={{ paddingLeft: 0 }}
				minTopDistance={drawerTopDistance}
			>
				<Box
					styles={{
						marginRight: rem(-24),
						height: '100%',
						overflow: 'hidden',
						borderRadius: rem(24, 24, 0, 0),
					}}
				>
					<PDFViewer
						ref={ref}
						height={pdfViewerHeight}
						download
						pdfProps={{
							name: title,
							resource: base64,
							resourceType: 'base64',
							allowTextSelection: true,
							onScroll: onScrolled,
						}}
						header={{
							title: title,
							text: subtitle,
							onBackArrowPress: hidePdfDrawer,
						}}
						footer={
							!wasAccepted
								? {
										text: t('general.pdfViewer.footer.descriptions.confirmReadAndAccepted'),
										buttonText: t('general.pdfViewer.footer.actions.confirmAndAccepted'),
										required: true,
										onComplete: handleOnClickAcceptTerms,
								  }
								: undefined
						}
						walkthroughOverlay={
							!wasAccepted && !scrolled
								? {
										zIndex: 3,
										text: t(
											'general.pdfViewer.walkthroughOverlay.descriptions.scrollToReadAndAccept'
										),
										button: {
											text: t('general.pdfViewer.walkthroughOverlay.actions.gotIt'),
										},
								  }
								: undefined
						}
					/>
				</Box>
			</Drawer>
		</>
	);
};
